import axios from 'axios'

const RESET = 'RESET'
const GET_QUALIFIERS_DATA_AND_CONFIGURATION = 'GET_QUALIFIERS_DATA_AND_CONFIGURATION'
const ADD_QUALIFIER_DATA = 'ADD_QUALIFIER_DATA'
const UPDATE_QUALIFIER_DATA = 'UPDATE_QUALIFIER_DATA'
const DELETE_QUALIFIER_DATA = 'DELETE_QUALIFIER_DATA'
const ADD_QUALIFIER_CONFIGURATION = 'ADD_QUALIFIER_CONFIGURATION'
const UPDATE_QUALIFIER_CONFIGURATION = 'UPDATE_QUALIFIER_CONFIGURATION'
const DELETE_QUALIFIER_CONFIGURATION = 'DELETE_QUALIFIER_CONFIGURATION'

const BASE_URL_getQualifiersAndConfiguration = (Id = '') => `api/ContinuousDataQualifier/GetQualifierDataAndConfiguration/${Id}`
const BASE_URL_addQualifierData = 'api/ContinuousDataQualifier/AddDataQualifier'
const BASE_URL_updateQualifierData = 'api/ContinuousDataQualifier/UpdateDataQualifier'
const BASE_URL_deleteQualifierData = (Id = '') => `api/ContinuousDataQualifier/DeleteDataQualifier/${Id}`
const BASE_URL_addConfiguration = 'api/ContinuousDataQualifier/AddQualifierConfiguration'
const BASE_URL_updateConfiguration = 'api/ContinuousDataQualifier/UpdateQualifierConfiguration'
const BASE_URL_deleteConfiguration = (Id = '') => `api/ContinuousDataQualifier/DeleteQualifierConfiguration/${Id}`
const BASE_URL_populateDefaultQualifiers = (Id = '') => `api/ContinuousDataQualifier/PopulateDefaultQualifiers/${Id}`

function initialState () {
  return {
    ContinuousDataQualifiers: [],
    ContinuousDataQualifierConfigurations: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getQualifiersDataAndConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_getQualifiersAndConfiguration(options)
        let res = await axios.get(url)
        commit(GET_QUALIFIERS_DATA_AND_CONFIGURATION, res.data)
      }
      catch(error) {
        console.error(error)
      }
    },
    async addQualifierData({ commit }, options) {
      try {
        let url = BASE_URL_addQualifierData
        let res = await axios.post(url, options.data)
        commit(ADD_QUALIFIER_DATA, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async updateQualifierData({ commit }, options) {
      try {
        let url = BASE_URL_updateQualifierData
        let res = await axios.post(url, options.data)
        commit(UPDATE_QUALIFIER_DATA, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async deleteQualifierData({ commit }, options) {
      try {
        let url = BASE_URL_deleteQualifierData(options.data)
        await axios.delete(url)
        commit(DELETE_QUALIFIER_DATA, options.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async addQualifierConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_addConfiguration
        let res = await axios.post(url, options.data)
        commit(ADD_QUALIFIER_CONFIGURATION, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async updateQualifierConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_updateConfiguration
        let res = await axios.post(url, options.data)
        commit(UPDATE_QUALIFIER_CONFIGURATION, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async deleteQualifierConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_deleteConfiguration(options.data)
        await axios.delete(url)
        commit(DELETE_QUALIFIER_CONFIGURATION, options.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async populateDefaultQualifers({ commit }, options) {
      try {
        let url = BASE_URL_populateDefaultQualifiers(options.data)
        await axios.post(url)
        options.successCb()
      }
      catch(error) {
        console.log(error)
        options.failedCb(error.response.data.Message)
      }
    },
  },

  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [GET_QUALIFIERS_DATA_AND_CONFIGURATION](state, data) {
      data.ContinuousDataQualifierConfigurations.forEach(x => x.ContinuousDataQualifiers = [])
      data.ContinuousDataQualifiers.forEach(x => {
        if (x.QualifierConfigurationId) {
          let target = data.ContinuousDataQualifierConfigurations.find(y => y.Id == x.QualifierConfigurationId)
          target.ContinuousDataQualifiers.push(x)
        }
      })
      state.ContinuousDataQualifiers = data.ContinuousDataQualifiers
      state.ContinuousDataQualifierConfigurations = data.ContinuousDataQualifierConfigurations
    },
    [ADD_QUALIFIER_DATA](state, data) {
      state.ContinuousDataQualifiers.push(data)
    },
    [UPDATE_QUALIFIER_DATA](state, data) {
      let index = state.ContinuousDataQualifiers.findIndex(x => x.Id == data.Id)
      state.ContinuousDataQualifiers.splice(index, 1, data)
      if (data.QualifierConfigurationId) {
        let targetConfiguration = state.ContinuousQualifierConfigurations.find(x => x.Id == data.QualifierConfigurationId)
        let targetIndex = targetConfiguration.ContinuousDataQualifiers.findIndex(x => x.Id == data.Id)
        targetConfiguration.ContinuousDataQualifiers.splice(targetIndex, 1, data)
      }
    },
    [DELETE_QUALIFIER_DATA](state, data) {
      let index = state.ContinuousDataQualifiers.findIndex(x => x.Id == data)
      state.ContinuousDataQualifiers.splice(index, 1)
    },
    [ADD_QUALIFIER_CONFIGURATION](state, data) {
      let ContinuousDataQualifiers = []
      data.ContinuousDataQualifiers.forEach(x => {
        state.ContinuousDataQualifiers.forEach(e => {
          if (e.Id == x.Id) {
            e.QualifierConfigurationId = data.Id
          }
        })
        ContinuousDataQualifiers.push({
          Id: x.Id,
          QualifierValue: x.QualifierValue,
          ShouldFilter: x.ShouldFilter,
          Level: x.Level,
          TenantId: x.TenantId,
          QualifierConfigurationId: data.Id,
        })
      })
      state.ContinuousDataQualifierConfigurations.push({
        Id: data.Id,
        Code: data.Code,
        Description: data.Description,
        Ordinal: data.Ordinal,
        TenantId: data.TenantId,
        ContinuousDataQualifiers: ContinuousDataQualifiers,
      })
    },
    [UPDATE_QUALIFIER_CONFIGURATION](state, data) {
      state.ContinuousDataQualifiers.forEach(x => {
        if (x.QualifierConfigurationId == data.Id) {
          x.QualifierConfigurationId = null
        }
      })
      state.ContinuousDataQualifiers.forEach(x => {
        data.ContinuousDataQualifiers.forEach(y => {
          if (x.Id == y.Id) {
            x.QualifierConfigurationId = data.Id
          }
        })
      })
      let index = state.ContinuousDataQualifierConfigurations.findIndex(x => x.Id == data.Id)
      state.ContinuousDataQualifierConfigurations.splice(index, 1, data)
    },
    [DELETE_QUALIFIER_CONFIGURATION](state, data) {
      let index = state.ContinuousDataQualifierConfigurations.findIndex(x => x.Id == data)
      state.ContinuousDataQualifierConfigurations.splice(index, 1)
      state.ContinuousDataQualifiers.forEach(x => {
        if (x.QualifierConfigurationId == data) {
          x.QualifierConfigurationId = null
        }
      })
    },
  },

  getters: {
    ContinuousDataQualifiers: state => state.ContinuousDataQualifiers,
    ContinuousDataQualifierConfigurations: state => state.ContinuousDataQualifierConfigurations,
    allValueItem: state => {
      let arr1 = []
      let arr2 = []
      state.ContinuousDataQualifiers.map(e => {
        if (e.ShouldFilter == false) {
          arr1.push(e.QualifierValue)
        }
      })
      state.ContinuousDataQualifierConfigurations.map(e => {
        e.ContinuousDataQualifiers.map(f => arr2.push(f.QualifierValue))
      })
      let RemoveSame = [...new Set([...arr1, ...arr2])]
      let SamePart = arr1.filter(item => arr2.includes(item))
      let Difference = RemoveSame.filter(item => !SamePart.includes(item))
      return Difference.sort()
    },
  },
}
